export default "__VITE_ASSET__bUXH55PM__"